"use strict";

import { Box, Text } from '@autoguru/overdrive';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const VehicleLookupMessageRenderer = /*#__PURE__*/memo(({
  suggestion
}) => /*#__PURE__*/_jsx(Box, {
  marginY: "2",
  paddingY: "1",
  paddingX: "4",
  backgroundColour: "white",
  display: "flex",
  onMouseDown: e => e.preventDefault(),
  children: /*#__PURE__*/_jsx(Text, {
    as: "p",
    colour: "muted",
    size: "2",
    children: suggestion.text
  })
}));